import service from "@irati/utils/tracking"
import {Deal} from "@irati/types"


class SearchTrackingEvents {
  startSearch(isRewards = false) {
    service.trackSearchEvent("perks_start_search", null, isRewards)
  }

  clickSearchResult(deal: Deal, isRewards = false) {
    const data = {
      perk_id: deal.uuid,
      perk_name: deal.header,
      perk_slug: deal.urlSlug,
      perk_category: deal.tagIds
    }
    service.trackSearchEvent("perks_click_search_result", data, isRewards)
  }

  abandonSearch(resultsLength: number, searchTerm: string, isRewards = false) {
    const data = {
      search_number_of_results: resultsLength,
      search_query: searchTerm
    }
    service.trackSearchEvent("perks_abandon_search", data, isRewards)
  }

}

export default new SearchTrackingEvents()
